<div class="return">

  <div *ngIf="!db.ismobile" class="order__items">
    <h2 class="h2 m-0 d__flex just-s">
      <!-- <span>Return Order</span> -->
      <span>Return Items From Order - {{order_id}}</span>
      <ion-icon class="close-ion-icon" src="assets/order_icon/close.svg" (click)="dismiss()"></ion-icon>
    </h2>

    <ion-row class="d__flex headings" *ngIf="false">
      <div class="ion-text-center image_title">ITEM NAME</div>
      <div class="ion-text-center qty">QTY</div>
      <div class="ion-text-center price">PRICE</div>
      <div class="ion-text-center div">Return</div>
      <div class="ion-text-center div">MRP TOTAL</div>
    </ion-row>
    <!-- return_products && return_products.order_item -->
    <!-- {{this.return_products_items | json}} -->
    <div class="product_box" *ngFor="let d of return_products.order_item">
      <!-- *ngIf="this.db.website_settings.return_based_on == 'Delivery Date' ? currentDate < d.delivery_date : currentDate < return_products.order_date" -->
      <div class="d__flex details">
        
        <div class="image_title">
         
          <div class="">
            <div class="free__item" *ngIf="d.is_free_item == 1">
              <div class="free__item__text fnt-12">FREE</div>
            </div>
            <img [src]="db.product_img(d.item_image)" />
          </div>
        </div>
          <div class="name">{{d.item_name}}</div>
          <div class="price open_sans__font">
            {{d.price | currency:'&#8377;'}}
          </div>
          <div class="d__flex just-s qty_button">
            <div class="ion-text-center div">
              <div class="cart-buttons mb-10">
                <div class="cart__button   d__flex just-s ion-activatable ripple-parent">
                  <ion-ripple-effect *ngIf="d.count == 0"></ion-ripple-effect>
                  <ion-button [disabled]="d.count == 0" class="mouse __button" (click)="remove(d)" fill="clear">
                    <span>-</span></ion-button>
                  <ion-spinner *ngIf="d.temp_disabled"></ion-spinner>
                  <div class="d__flex">
                    <span class="add" [class.not__added]="d.count == 0" [class._added]="d.count != 0">
                      {{d.count && (d.count != 0)?d.count:'0'}}
                    </span>
                  </div>
                  <!-- <span class="add" [class.not__added]="item.count == 0" [class._added]="item.count != 0" *ngIf="!item.temp_disabled" > {{item.count && (item.count != 0)?item.count:'ADD'}} </span> -->
                  <ion-button class="mouse __button" (click)="add(d)" [disabled]="d.count == d.quantity"
                    fill="clear"><span>+</span></ion-button>
                </div>
              </div>
            </div>
          </div>

          <div class="ion-text-center button_return _button">
            <ion-button fill="clear" (click)="return(d)">Make Return</ion-button>
          </div>
        <!-- <div class="ion-text-center div">
          {{d.amount | currency:'&#8377;'}}
        </div> -->
        <!-- *ngIf="this.db.website_settings.return_based_on == 'Delivery Date' ? currentDate < d.delivery_date : currentDate < return_products.order_date" -->

      </div>
    </div>
  </div>

  <div *ngIf="db.ismobile" class="order__items">
    
    <div class="d__flex just-s heading_">
      <h6 class="h2">Item Details</h6>
      <ion-icon class="close-ion-icon" src="assets/order_icon/close.svg" (click)="dismiss()"></ion-icon>
    </div>

    <div class="list_view" *ngFor="let d of return_products.order_item">
      <div class="d__flex gap-10 list">
        <div class="image__container__mb">
          <div class="free__item" *ngIf="d.is_free_item == 1">
            <div class="free__item__text">FREE</div>
          </div>
          <img [src]="db.product_img(d.item_image)" />
        </div>
        <div class="info__container_mb">
          <div class="fnt-13 mb-3">{{d.item_name}}</div>
          <div [innerHTML]="d.attribute_description"></div>
          <div class="d__flex gap-10">
            <!-- <div class="price_mb">
              <p class="m-0 fnt-9">Price</p>
              <div class="fnt-13">{{d.price | currency:'&#8377;'}}</div>
            </div> -->
            <!-- <div class="qty_mb">
              <p class="m-0 fnt-9">Qty</p>
              <div class="fnt-13">{{d.quantity}}</div>
            </div> -->
            <div class="total_mb">
              <p class="m-0 fnt-9">Amount</p>
              <div class="fnt-13 open_sans__font">{{d.amount | currency:'&#8377;'}}</div>
            </div>
          </div>
          <!-- <ion-col size="3" class="ion-text-center">  </ion-col>
          <ion-col size="2" class="ion-text-center">  </ion-col>
          <ion-col size="2" class="ion-text-center">   </ion-col> -->
        </div>
      </div>
      <div class="d__flex make_return">
        <div class="ion-text-center div">
          <div class="cart-buttons d__flex just-c">

            <div class="cart__button ion-activatable ripple-parent d__flex">
              <ion-ripple-effect *ngIf="d.count == 0"></ion-ripple-effect>
              <ion-button [disabled]="d.count == 0" class="mouse __button" (click)="remove(d)" fill="clear">
                <span>-</span></ion-button>
              <ion-spinner *ngIf="d.temp_disabled"></ion-spinner>
              <div class="d__flex">
                <span class="add" [class.not__added]="d.count == 0" [class._added]="d.count != 0">
                  {{d.count && (d.count != 0)?d.count:'0'}}
                </span>
              </div>
              <!-- <span class="add" [class.not__added]="item.count == 0" [class._added]="item.count != 0" *ngIf="!item.temp_disabled" > {{item.count && (item.count != 0)?item.count:'ADD'}} </span> -->
              <ion-button class="mouse __button" (click)="true?add(d):''" [disabled]="d.count == d.quantity"
                fill="clear"><span>+</span></ion-button>
            </div>
            
          </div>
        </div>

        <div class="ion-text-center button_return _button">
          <ion-button fill="clear" (click)="return(d)">Make Return</ion-button>
        </div>
      </div>
    </div>
  </div>
</div>